import React from 'react';
import { t, tf } from '../utils/i18n';
import {
  formatMoneyAmount,
  formatProductPriceLine,
  getProductSalePricing
} from '../utils/productPricing';

/**
 * Renders catalog product pricing with optional compare-at discount.
 */
export default function ProductPriceBlock({
  product,
  language,
  onRequestLabel,
  monthlySuffix = '',
  variant = 'card'
}) {
  const pricing = getProductSalePricing(product);
  const { salePrice, compareAt, currency, hasDiscount, discountPercent } = pricing;
  const blockClass = variant === 'page'
    ? 'product-page-price-block'
    : variant === 'compact'
      ? 'offer-price-block offer-price-block-compact'
      : 'offer-price-block';

  if (!Number.isFinite(salePrice) || salePrice <= 0) {
    return (
      <div className={blockClass}>
        <div className={variant === 'page' ? 'product-page-price' : 'offer-price'}>
          {onRequestLabel || t('landing.productPriceOnRequest', language)}
        </div>
      </div>
    );
  }

  const saleLine = formatProductPriceLine(salePrice, currency, monthlySuffix);
  const compareLine = hasDiscount
    ? formatProductPriceLine(compareAt, currency, monthlySuffix)
    : null;

  return (
    <div className={blockClass}>
      {hasDiscount && (
        <div className="offer-discount-row">
          <span className="offer-discount-badge">
            {tf('landing.productOfferBadge', { percent: String(discountPercent) }, language)}
          </span>
        </div>
      )}
      {hasDiscount && compareLine && (
        <div className={variant === 'page' ? 'product-page-price-compare' : 'offer-price-compare'} aria-hidden>
          {compareLine}
        </div>
      )}
      <div className={variant === 'page' ? 'product-page-price' : 'offer-price'}>
        {variant === 'page' ? (
          <>
            {formatMoneyAmount(salePrice)}
            <span className="product-page-currency"> {currency}{monthlySuffix}</span>
          </>
        ) : (
          saleLine
        )}
      </div>
    </div>
  );
}
